import { Component } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { StorageKeyNamesManage } from 'src/app/constants';
import { StorageService } from 'src/app/shared/services/storage.service';
import { SharedDataService } from 'src/app/shared/shared-data.service';
import { SharedService } from 'src/app/shared/shared.service';
import { VendorAppPromotedRendererComponent } from '../../cell-renderers/vendor-app-promoted-renderer/vendor-app-promoted-renderer.component';
import { ServerSideGridBase } from '../server-side-grid.base';

@Component({
  selector: 'app-vendor-apps',
  templateUrl: './vendor-apps.component.html',
  styleUrls: ['./vendor-apps.component.scss'],
})
export class VendorAppsComponent extends ServerSideGridBase {

  protected storageKey = StorageKeyNamesManage.vendorAppList;
  protected gridIdSuffix = 'vendorAppsGrid';

  protected initialFilters = {
    'app-name': '',
    'app-status': '',
    'promoted-app': '',
  };

  protected initialSorts = {
    app_name: '',
    app_status: '',
    promoted_app: '',
  };

  override defaultColDef: ColDef = {
    sortable: true,
    comparator: () => 0,
    filter: false,
    headerTooltip: '',
    tooltipField: 'payload',
    cellDataType: false,
    flex: 1,
  };

  columnDefs: ColDef[] = [
    {
      flex: 1,
      headerName: 'Name',
      field: 'app_name',
      maxWidth: 150,
    },
    {
      flex: 1,
      headerName: 'Description',
      field: 'short_description',
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      headerName: 'Application Status',
      headerClass: 'header-label-center',
      cellRenderer: (params: any) => {
        const divOuter = document.createElement('div');
        divOuter.classList.add('text-center', 'fixed-badge');
        const divInner = document.createElement('div');
        divInner.classList.add('badge');
        if (params.data && params.data.app_status) {
          if (params.data.app_status === 'IN_REVIEW') {
            divInner.innerHTML = 'IN REVIEW';
            divInner.classList.add('btn-custom-info');
          } else if (params.data.app_status === 'SUBMITTED') {
            divInner.innerHTML = 'SUBMITTED';
            divInner.classList.add('btn-custom-info');
          } else if (params.data.app_status === 'PUBLISHED') {
            divInner.innerHTML = 'PUBLISHED';
            divInner.classList.add('btn-custom-pri');
          } else if (params.data.app_status === 'ALPHA') {
            divInner.innerHTML = 'ALPHA';
            divInner.classList.add('btn-custom-pri');
          } else if (params.data.app_status === 'BETA') {
            divInner.innerHTML = 'BETA';
            divInner.classList.add('btn-custom-pri');
          } else if (params.data.app_status === 'REVOKED') {
            divInner.innerHTML = 'REVOKED';
            divInner.classList.add('btn-custom-danger');
          } else {
            divInner.innerHTML = '';
          }
        } else {
          divInner.innerHTML = '';
        }
        divOuter.appendChild(divInner);
        return divOuter;
      },
      sortable: false,
    },
    {
      flex: 1,
      headerName: 'Promoted Status',
      field: 'promoted_app',
      cellRenderer: 'vendorAppPromotedRenderer',
      headerClass: 'header-label-center',
      sortable: false,
    },
    {
      flex: 1,
      headerName: 'Associated CSP(s)',
      headerClass: 'header-label-center',
      cellRenderer: (params: any) => {
        const divOuter = document.createElement('div');
        divOuter.classList.add('text-center');
        divOuter.title = 'View';
        const button = document.createElement('button');
        button.className = 'btn btn-sm btn-custom-pri';
        button.innerHTML = ' <i class="fa-regular fa-eye fa-fw"></i>';
        button.id = this.idString + 'vapBtn-' + params.rowIndex;
        divOuter.appendChild(button);
        button.addEventListener('click', () => this.viewPartners(params));
        return divOuter;
      },
      sortable: false,
    },
  ];

  frameworkComponents = {
    vendorAppPromotedRenderer: VendorAppPromotedRendererComponent,
  };

  constructor(
    storageService: StorageService,
    sharedService: SharedService,
    private sharedDataService: SharedDataService,
  ) {
    super(storageService, sharedService);
  }

  viewPartners(params: any): void {
    this.sharedDataService.associatedPartnersLinkSub.next(params);
  }

  protected mapFilterModel(filterModel: any): void {
    this.urlParams.filters['app-name'] = filterModel.app_name ? filterModel.app_name.value : '';
    this.urlParams.filters['app-status'] = filterModel.app_status ? filterModel.app_status.value : '';
    this.urlParams.filters['promoted-app'] = filterModel.promoted_app ? filterModel.promoted_app.value : '';
  }

  protected mapSortModel(sortModel: any[]): void {
    Object.keys(this.urlParams.sorts).forEach(k => (this.urlParams.sorts[k] = ''));
    sortModel.forEach((elem: any) => {
      if (elem.colId in this.urlParams.sorts) {
        this.urlParams.sorts[elem.colId] = elem.sort;
      }
    });
  }
}
